import React, {useState} from "react";
import {HelpFile} from "../model";
import {Alert, Button, Modal} from "react-bootstrap";
import {XIcon} from "lucide-react";

type VideoProps = {
    document: HelpFile,
    text?: string
}

export const Video = ({document, text} : VideoProps) => {

    // const now = new Date().getTime();
    const [show, setShow] = useState(false);
    const [error, setError] = useState('')
    const handleClose = () => setShow(false);
    const handleShow = () => {
        if (!document.helpUrl) {
            setError('URL invalide')
        }
        else {
            setShow(true);
        }
    }

    return (
        <>
            <Button
                variant={'outline-primary'}
                style={{ right: '.5rem', bottom: '.5rem' }}
                onClick={handleShow}
                disabled={!!error}
            >
                {
                    error
                        ? `Erreur [${error}]`
                        : text ?? `Lecture`
                }
            </Button>
            <Modal
                show={show}
                onHide={handleClose}
                animation={false}
                backdrop={"static"}
                keyboard={false}
                fullscreen
            >
                <Modal.Header closeButton>
                    <Modal.Title>{document.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{overflow: 'hidden'}}>
                    {
                        document.helpUrl
                            ? <iframe
                                title={`${document.name} youtube`}
                                width="100%"
                                height="100%"
                                src={`${document.helpUrl}?vq=hd1080`}
                                allowFullScreen
                            />
                            : <Alert variant={'danger'} className={'d-flex-center flex-column gap-3'}>
                                <div>Erreur lors du chargement de la vidéo.</div>
                                <Button variant={'danger'} onClick={handleClose}>
                                    <XIcon/> Fermer
                                </Button>
                            </Alert>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}